import script from "./bindLoading.vue?vue&type=script&lang=ts&setup=true"
export * from "./bindLoading.vue?vue&type=script&lang=ts&setup=true"

import "./bindLoading.vue?vue&type=style&index=0&id=26cc6f20&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26cc6f20"]])

export default __exports__